import {
  Box,
  FormControl,
  FormLabel,
  HStack,
  Switch,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import ProjectInformation from "./steps/projectInformation";
import ProblemStatement from "./steps/problemStatement";
import { color } from "../../../../../utils/theme";
import AimStatement from "./steps/aimStatment";
import RootCauseAnalysis from "./steps/rootCauseAnalysis";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/reducer/rootReducer";
import { createProject, getProjectPayload } from "./projectService";
import { useNavigate } from "react-router-dom";
import FocusingMatrix from "./steps/focusingMatrix";
import Prioritization from "./steps/prioritization";
import Driver from "./steps/prioritization/driver";
import ProjectMeasurment from "./steps/measurment";

const NewProject = () => {
  const [selectedSteps, setSelectedSteps] = useState(0);
  const formState = useSelector((state: RootState) => state.form);
  const [isSaveLoading, setIsSaveLoading] = useState(false);

  const formStateRef = useRef(formState);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    formStateRef.current = formState;
  }, [formState]);

  const handleTabsChange = (index: number) => {
    setSelectedSteps(index);
  };

  const saveAndExit = async () => {
    console.log(formStateRef.current);
    setIsSaveLoading(true);
    const formData: { [key: string]: any } = formStateRef.current.formData;
    const payLoad = getProjectPayload(formData);
    const response = await createProject(payLoad);
    setIsSaveLoading(false);
    if (response.success) {
      console.log("Project created successfully");
      toast({
        title: "Project Saved Successfully",
        position: "top-right",
        description: "Your project has been saved successfully",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      setTimeout(() => {
        navigate("/quality-improvement/qi-project/existing-projects");
      }, 2000);
    } else {
      console.log("Project creation failed");
      toast({
        title: "Something went wrong",
        position: "top-right",
        description: "Project could not be saved.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const steps = [
    {
      title: "Project Information",
      component: (
        <ProjectInformation
          onNext={() => handleTabsChange(1)}
          onSave={saveAndExit}
          loading={isSaveLoading}
        />
      ),
    },
    {
      title: "Problem Statement",
      component: (
        <ProblemStatement
          onPrev={() => handleTabsChange(0)}
          onNext={() => handleTabsChange(2)}
          onSave={saveAndExit}
          loading={isSaveLoading}
        />
      ),
    },
    {
      title: "Aim Statement",
      component: (
        <AimStatement
          onPrev={() => handleTabsChange(1)}
          onNext={() => handleTabsChange(3)}
          onSave={saveAndExit}
        />
      ),
    },
    {
      title: "Root Cause Analysis",
      component: (
        <RootCauseAnalysis
          onPrev={() => handleTabsChange(2)}
          onNext={() => handleTabsChange(4)}
          onSave={saveAndExit}
        />
      ),
    },
    {
      title: "Prioritization",
      component: (
        <Prioritization
          onPrev={() => handleTabsChange(3)}
          onNext={() => handleTabsChange(5)}
          onSave={saveAndExit}
          loading={isSaveLoading}
          goToLastStep={true}
        />
      ),
    },
    {
      title: "Driver Diagram",
      component: (
        <Driver
          onPrev={() => handleTabsChange(4)}
          onNext={() => handleTabsChange(6)}
          onSave={saveAndExit}
          loading={isSaveLoading}
        />
      ),
    },
    {
      title: "Focusing Matrix",
      component: (
        <FocusingMatrix
          onPrev={() => handleTabsChange(5)}
          onNext={() => handleTabsChange(7)}
          onSave={saveAndExit}
          loading={isSaveLoading}
        />
      ),
    },
    {
      title: "Measurements",
      component: (
        <ProjectMeasurment
          onPrev={() => handleTabsChange(6)}
          onNext={() => saveAndExit}
          onSave={saveAndExit}
          loading={isSaveLoading}
        />
      ),
    },
  ];
  return (
    <Box
      w="100%"
      h="100%"
      display="flex"
      flexDirection="column"
      alignContent="center"
      alignItems="center"
    >
      <Tabs
        isFitted
        isLazy
        index={selectedSteps}
        w="90%"
        h={"full"}
        my={20}
        onChange={(index) => handleTabsChange(index)} // Keep programmatic navigation
      >
        <HStack
          alignContent={"flex-end"}
          justifyContent={"flex-end"}
          alignItems={"flex-end"}
          width={"100%"}
          my={2}
        >
          <FormControl
            display="flex"
            alignItems="center"
            alignSelf={"flex-end"}
            w={"fit-content"}
          >
            <FormLabel htmlFor="email-alerts" mb="0">
              Enable Voice Assist?
            </FormLabel>
            <Switch id="email-alerts" />
          </FormControl>
        </HStack>
        <TabList>
          {steps.map((step, index) => (
            <Tab
              key={index}
              _active={{ fontWeight: "bold", color: color.primary }}
              sx={
                selectedSteps === index
                  ? { fontWeight: "bold", color: color.primary, fontSize: 17 }
                  : {}
              }
              onClick={(e) => e.preventDefault()}
              isDisabled={true}
              _disabled={
                selectedSteps === index
                  ? { color: color.primary }
                  : { color: color.text }
              }
              _hover={{ cursor: "not-allowed" }}
              fontSize={15}
            >
              {step.title}
            </Tab>
          ))}
        </TabList>
        <TabPanels h={"full"}>
          {steps.map((step, index) => (
            <TabPanel h={"full"} key={index}>
              {step.component}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default NewProject;
